import { defineMessages, FormattedMessage } from 'react-intl';

import type { SearchViewType } from '@/components/Search/types';

const prefix = 'searchView';
export const searchViewMessages = defineMessages({
  all: {
    id: `searchView.searchViewType.all`,
    defaultMessage: 'all',
  },
  store: {
    id: `searchView.searchViewType.store`,
    defaultMessage: 'store',
  },
  stores: {
    id: `searchView.searchViewType.stores`,
    defaultMessage: 'stores',
  },
  watches: {
    id: `searchView.searchViewType.watches`,
    defaultMessage: 'watches',
  },
  watch: {
    id: `searchView.searchViewType.watch`,
    defaultMessage: 'watch',
  },
  strap: {
    id: `searchView.searchViewType.strap`,
    defaultMessage: 'strap',
  },
  straps: {
    id: `searchView.searchViewType.straps`,
    defaultMessage: 'straps',
  },
  eyewear: {
    id: `common.eyewear`,
    defaultMessage: 'sunglasses',
  },
});
export const YourResults = (numResults: number) => (
  <FormattedMessage
    defaultMessage='Your results ({numResults})'
    id={`${prefix}.yourResults`}
    values={{
      numResults,
    }}
  />
);
export const YourResultsLoading = () => (
  <FormattedMessage
    defaultMessage='Your results'
    id={`${prefix}.yourResults.loading`}
  />
);

export const TotalResults = (numResults: number) => (
  <FormattedMessage
    defaultMessage='{numResults, plural, one {# Result} other {# Results}}'
    id={`${prefix}.totalResults`}
    values={{
      numResults,
    }}
  />
);

export const TranslatedFilter = (type: SearchViewType, numResults: number) => {
  let transformedType: any = type;
  switch (transformedType) {
    case 'all':
      transformedType = <FormattedMessage {...searchViewMessages.all} />;
      break;
    case 'stores':
      transformedType = <FormattedMessage {...searchViewMessages.stores} />;
      break;
    case 'watches':
      transformedType = <FormattedMessage {...searchViewMessages.watches} />;
      break;
    case 'eyewear':
      transformedType = <FormattedMessage {...searchViewMessages.eyewear} />;
      break;
    default:
      transformedType = <FormattedMessage {...searchViewMessages.straps} />;
  }
  return (
    <FormattedMessage
      defaultMessage='{type} ({numResults})'
      id={`${prefix}.${type}`}
      values={{
        numResults,
        type: transformedType,
      }}
    />
  );
};

export const TranslatedFilterLoading = (type: SearchViewType) => (
  <FormattedMessage
    defaultMessage='{type} '
    id={`${prefix}.${type}.loading`}
    values={{
      type,
    }}
  />
);

export const WeFoundWatchNumResults = (numResults: number) => {
  const watch =
    numResults === 1 ? (
      <FormattedMessage {...searchViewMessages.watch} />
    ) : (
      <FormattedMessage {...searchViewMessages.watches} />
    );
  return (
    <FormattedMessage
      defaultMessage='We found {numResults} {watch} for you'
      id={`${prefix}.weFoundWatchNumResults`}
      values={{
        numResults,
        watch,
      }}
    />
  );
};

export const WeFoundStrapNumResults = (numResults: number) => {
  const strap =
    numResults === 1 ? (
      <FormattedMessage {...searchViewMessages.strap} />
    ) : (
      <FormattedMessage {...searchViewMessages.straps} />
    );
  return (
    <FormattedMessage
      defaultMessage='We found {numResults} {strap} for you'
      id={`${prefix}.weFoundStrapNumResults`}
      values={{
        numResults,
        strap,
      }}
    />
  );
};

export const WeFoundStoresNumResults = (numResults: number) => {
  const store =
    numResults === 1 ? (
      <FormattedMessage {...searchViewMessages.store} />
    ) : (
      <FormattedMessage {...searchViewMessages.stores} />
    );
  return (
    <FormattedMessage
      defaultMessage='We found {numResults} {store} for you'
      id={`${prefix}.weFoundStoreNumResults`}
      values={{
        numResults,
        store,
      }}
    />
  );
};

export const WeFoundEyewearNumResults = (numResults: number) => {
  const eyewear = <FormattedMessage {...searchViewMessages.eyewear} />;
  return (
    <FormattedMessage
      defaultMessage='We found {numResults} {eyewear} for you'
      id={`${prefix}.weFoundStrapNumResults`}
      values={{
        numResults,
        strap: eyewear,
      }}
    />
  );
};
